export const StatusEnum = {
  ACTIVE: "Active",
  INACTIVE: "Inactive",
};


